import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { logError, notification, modal } from 'redux/modules/app'
import { tasks as tasksApi } from 'redux/modules/api'
import { combineAnd } from 'utils/apiFilter'
import { EMAIL_REVISION_ACTION_REQUESTS } from 'constants/enums'

function decorator(config = {}) {
  return ComposedComponent => {
    @connect(
      ({ auth, app, api }) => ({
        local: {
          user: auth.user,
          activeOrganizationId: auth.organization.id
        },
        tasksEmailRevision: api.tasks.emailRevision,
        user: auth.user,
        commonLimit: app.commonLimit
      }),
      {
        ...tasksApi.emailRevision,
        getTasksOverview: tasksApi.overview.getTasksOverview,
        notification,
        logError,
        modal
      }
    )
    class TasksEmailRevision extends Component {
      static propTypes = {
        decoFilter: PropTypes.string,
        decoFilterMyOnly: PropTypes.bool,
        getTasksOverview: PropTypes.func.isRequired,
        tasks: PropTypes.object,
        tasksEmailRevision: PropTypes.object.isRequired,
        getTasksEmailRevision: PropTypes.func.isRequired,
        resetTasksEmailRevision: PropTypes.func.isRequired,
        clearEmailRevision: PropTypes.func.isRequired,
        emailRevisionAction: PropTypes.func.isRequired,
        setTasksEmailRevisionParams: PropTypes.func,
        commonLimit: PropTypes.number,
        user: PropTypes.object,
        local: PropTypes.object,
        notification: PropTypes.func,
        logError: PropTypes.func,
        modal: PropTypes.func
      }

      defaultProps = {
        tasks: {}
      }

      componentDidMount() {
        const { tasksEmailRevision, decoFilterMyOnly, commonLimit, setTasksEmailRevisionParams } = this.props

        if (config.useCommonLimit && commonLimit
            && tasksEmailRevision && tasksEmailRevision.emailRevision) {
          config.emailRevision && setTasksEmailRevisionParams({ limit: commonLimit })
        } else {
          config.emailRevision && this.handleGetTasksEmailRevision(tasksEmailRevision.emailRevision, decoFilterMyOnly)
        }
      }

      componentWillReceiveProps(nextProps) {
        const { tasksEmailRevision: { emailRevision },
          decoFilterMyOnly
        } = this.props
        const { filter, limit, offset, sort, invalidate } = nextProps.tasksEmailRevision.emailRevision

        if (
          emailRevision.filter !== filter ||
          emailRevision.limit !== limit ||
          emailRevision.offset !== offset ||
          emailRevision.sort !== sort ||
          emailRevision.invalidate !== invalidate ||
          decoFilterMyOnly !== nextProps.decoFilterMyOnly
        ) {
          config.emailRevision &&
            this.handleGetTasksEmailRevision(nextProps.tasksEmailRevision.emailRevision, nextProps.decoFilterMyOnly)
        }
      }

      componentWillUnmount = () => {
        this.props.resetTasksEmailRevision()
      }

      handleGetTasksEmailRevision = (tasks, myOnly) => {
        const personId = this.props.user.personId
        const filterMyOnly = myOnly || this.props.decoFilterMyOnly
        const combinedFilter = combineAnd(tasks.filter,
          filterMyOnly
            ? `awardLeader.person.id=${personId}`
            : '')

        return this.props.getTasksEmailRevision({ ...tasks, filter: combinedFilter })
      }

      handleClearEmailRevision = emailId =>
        this.props
          .clearEmailRevision(emailId)
          .catch(this.handleError)
          .then(this.handleRefresh)

      handleCanNotifyEmailRevision = dataItem =>
        dataItem.actionRequest === EMAIL_REVISION_ACTION_REQUESTS.ACTIVITY_ASSESSMENT_REQUEST.id
        || dataItem.actionRequest === EMAIL_REVISION_ACTION_REQUESTS.RP_ASSESSMENT_REQUEST.id

      actionTypeForCategory = {
        ACTIVITY_ASSESSMENT_REQUEST: 'RESET_ACTIVITY',
        RP_ASSESSMENT_REQUEST: 'RESET_RP'
      }

      handleNotifyEmailRevision = (emailId, category, fields) =>
        this.props
          .emailRevisionAction(emailId, {
            note: fields.note,
            actionType: this.actionTypeForCategory[category] || 'RESET_ACTIVITY'
          })
          .catch(this.handleError)
          .then(this.handleRefresh)

      handleError = err => {
        this.props.logError(err)
        this.props.modal(null)
        if (err && err.body) {
          console.debug('error', err.body && err.body.userMessage)
          this.props.notification(err.body.userMessage || 'Error', 'error')
        }
      }

      handleRefresh = () => {
        const { tasksEmailRevision, decoFilterMyOnly } = this.props

        if (config.emailRevision) {
          this.handleGetTasksEmailRevision(tasksEmailRevision.emailRevision, decoFilterMyOnly)

          this.props.getTasksOverview(null, {
            activeOrganizationId: this.props.local.activeOrganizationId,
            awardLeaderId: this.props.local.user.personId
          })
        }
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            tasks={{ ...this.props.tasks, ...this.props.tasksEmailRevision }}
            clearEmailRevision={this.handleClearEmailRevision}
            canNotifyEmailRevision={this.handleCanNotifyEmailRevision}
            notifyEmailRevision={this.handleNotifyEmailRevision}
          />
        )
      }
    }
    return TasksEmailRevision
  }
}

export default decorator
